import { menuBar, nativeWindow, object, tray } from "@todesktop/client-core";
import { TRAY_ID } from "../DesktopAppConstants";

const addOnShowMenubarWindowEventListener = (cb: () => void): (() => void) | null => {
    if (window.todesktop) {
        menuBar.on("show", cb).then((unsubscribe: () => void) => {
            return unsubscribe;
        });
    }
    return null;
};

const addOnTrayClickEventListener = async (cb: () => void): Promise<(() => Promise<void>) | null> => {
    if (window.todesktop) {
        const trayRef = await object.retrieve({ id: TRAY_ID });
        if (trayRef) {
            return tray.on("click", cb, { ref: trayRef });
        }
        return null;
    }
    return null;
};

export const registerAppMenuEventListener = async (eventName: string, cb: (event: string) => void) => {
    if (window.todesktop) {
        return await object.on(eventName, () => cb(eventName));
    }
    return null;
};

const addOnHideMenubarWindowEventListener = (cb: () => void): (() => void) | null => {
    if (window.todesktop) {
        menuBar.on("hide", cb).then((unsubscribe: () => void) => {
            return unsubscribe;
        });
    }
    return null;
};

const addOnCloseMainWindowEventListener = (cb: () => void): (() => void) | null => {
    if (window.todesktop) {
        nativeWindow.on("close" as any, cb).then((unsubscribe: () => void) => {
            return unsubscribe;
        });
    }
    return null;
};

const addOnShowMainWindowEventListener = (cb: () => void): (() => void) | null => {
    if (window.todesktop) {
        nativeWindow.on("show" as any, cb).then((unsubscribe: () => void) => {
            return unsubscribe;
        });
    }
    return null;
};

export {
    // menubar
    addOnHideMenubarWindowEventListener,
    addOnShowMenubarWindowEventListener,
    addOnTrayClickEventListener,
    // main window
    addOnCloseMainWindowEventListener,
    addOnShowMainWindowEventListener,
};
